export default {
  close: 'Close',
  file: 'File',
  goBack: 'Go Back to Excel Import',
  excelOrders: 'Excel Orders',
  poNumber: 'PO#',
  result: 'Result',
}
